import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='life-insurance'
      backgroundVariant='darkDefault'
      headingText={<>Now you&#39;re ready for a life <WidowBlock>insurance quote.</WidowBlock></>}
      text='Your advisor will ask deeper questions to help find the right type, and amount, of life insurance for your goals and budget.'
      subText= {<>It&#39;s easy to get started&#8212;no commitment, just a better conversation.</>}
    />
  );
};
